<ng-container>
  <div class="row p-4">
    <div class="d-flex justify-content-lg-between design-container overflow-hidden mt-lg-4 flex-lg-row flex-sm-column-reverse mt-sm-0 m-sm-0 p-sm-0">
      <div class="pd-design-header d-flex align-items-lg-center flex-lg-row flex-sm-column">
        <span>Customize <span *ngIf="brand && style && color" class="pd-garment-label ms-2">{{brand}} {{style}} {{color}}:</span></span>
        <span class="fw-normal fs-6 ms-lg-2 ms-sm-0" (click)="editDesignNameModal()">{{designObject?.name ?? ''}} <i *ngIf="designObject?.name" class="fas fa-pen fa-xs ms-lg-2 cursor pointer" (click)="editDesignNameModal()" mdbTooltip="Edit design name"></i></span>
      </div>
      <button type="button" class="btn btn-link pd-link p-sm-0 align-self-sm-end mb-sm-1" aria-label="return to product" (click)="goBack()">
        <i class="fas fa-undo"></i> <span class="ps-2">Back to Product</span>
      </button>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-3 design-overflow-scroll d-none d-lg-block">
          <!-- Product design library -->
          <product-design-library *ngIf="!mobileView" (uploadArtEvent)="openUploadArtModal($event)" (selectedDesignFile)="handleImageClick($event)" (removeDesignFile)="onRemoveImage($event)" [designFiles]="designFiles"></product-design-library>
        </div>
        <div class="col-12 col-lg-6 design-overflow-scroll">
          <!-- Product design tool -->
          <product-design-tool
            [variant]="selectedProductVariant"
            (decorationType)="selectedDecorationType($event)"
            [designMockups]="designMockups$|async"
            [designObject]="designObject"
            (selectedPosition)="changePosition($event)"
            [cartId]="cartId"
            (selectedDesignFile)="handleImageClick($event)"
            (uploadArtEvent)="openUploadArtModal()"
            [designFiles]="designFiles"
          ></product-design-tool>
        </div>
        <div class="col-12 col-lg-3 design-overflow-scroll">
          <!-- Product design options -->
          <product-design-options *ngIf="productSizes" [sizes]="productSizes" [variant]="selectedProductVariant" [decorationType]="decorationType"
          [position]="selectedPosition" (selectedPosition)="changePosition($event)" (priceChangesEvent)="priceChanges($event)"
          [product]="product" [designName]="designName" [designObject]="designObject" [designId]="designId" [cartId]="cartId"></product-design-options>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- </div> -->

